<template>
  <b-modal
    id="import-modal"
    v-model="isShowModal"
    title="Cập nhật PT TMĐT theo lô"
    size="lg"
    centered
    @hide="handleClose"
  >
    <div class="modal-body">
      <!-- File upload buttons - always visible -->
      <div class="d-flex mb-3 ml-2">
        <b-button variant="outline-primary" class="mr-2" @click="handleDownloadTemplate">
          <i class="bx bx-download"></i>
          {{ loadingDownTemplate ? 'Đang tải...' : 'Tải file mẫu' }}
        </b-button>

        <b-button
          variant="outline-success"
          @click="$refs.fileInput.click()"
          :disabled="loadingUpload"
        >
          <i class="bx bxs-file-plus"></i>
          {{ loadingUpload ? 'Đang tải...' : 'Tải lên file' }}
        </b-button>
      </div>

      <!-- Upload UI when no file uploaded -->

      <div
        v-if="!isUploaded && !loadingUpload"
        class="upload-container py-4"
        style="cursor: pointer"
        @click="$refs.fileInput.click()"
      >
        <div class="upload-icon">
          <i class="bx bxs-cloud-upload"></i>
        </div>
        <h5>Tải lên file Excel để cập nhật dữ liệu</h5>
        <small class="text-muted">Hỗ trợ định dạng: .xlsx, .xls, .csv</small>
      </div>

      <div class="py-5 text-center" v-if="loadingUpload">
        <h6>Đang tải dữ liệu....</h6>
      </div>

      <!-- Results Table - only shown when data is uploaded -->
      <div class="mb-3" v-if="isUploaded && !loadingUpload">
        <div class="mt-1 mb-2">
          <b-badge variant="success" class="mr-2">Thành công: {{ successCount }}</b-badge>
          <b-badge variant="danger">Thất bại: {{ failedCount }}</b-badge>
        </div>

        <b-table
          :items="processedItems"
          :fields="fields"
          striped
          hover
          :busy.sync="loadingUpload"
          sticky-header
          responsive
          fixed
          bordered
        >
          <template #cell(index)="data">
            <span>{{ data.index + 1 }}</span>
          </template>
          <template #cell(status)="{ item }">
            <b-badge :variant="item.status === 'SUCCESS' ? 'success' : 'danger'">{{
              getNameStatus(item.status)
            }}</b-badge>
          </template>
        </b-table>
      </div>

      <!-- Hidden file input -->
      <input
        type="file"
        ref="fileInput"
        @change="handleFileChange"
        accept=".xlsx,.xls,.csv"
        class="d-none"
      />
    </div>

    <template #modal-footer>
      <b-button variant="light" @click="handleClose">Đóng</b-button>
    </template>
  </b-modal>
</template>

<script>
  import { showMess } from '@/config/utils'
  import { ReceiptService } from '@/services/receipts.service'
  export default {
    name: 'ImportModal',
    props: ['onLoad'],
    data() {
      return {
        isShowModal: false, // AI
        loadingUpload: false, // AI
        loadingDownTemplate: false, // AI
        isUploaded: false, // AI
        processedItems: [],
        successCount: 0,
        failedCount: 0,
        statusOptions: [
          { id: 'ERROR', name: 'Thất bại' },
          { id: 'SUCCESS', name: 'Thành công' },
        ],
        fields: [
          // AI
          {
            // AI
            key: 'index', // AI
            label: 'STT', // AI
            tdClass: 'text-center', // AI
            thClass: 'text-center', // AI
          },
          { key: 'serial', label: 'Serial TB' }, // AI
          { key: 'status', label: 'Trạng thái' }, // AI
          {
            // AI
            key: 'errors', // AI
            label: 'Ghi chú',
            tdClass: 'text-wrap', // AI
            thClass: 'text-center', // AI
            thStyle: { 'min-width': '200px', width: '200px' }, // AI
            formatter: (
              value // AI
            ) => (Array.isArray(value) ? value.join(', ') : value), // AI
          }, // AI
        ], // AI
      } // AI
    }, // AI
    computed: {
      // AI
      getNameStatus() {
        // AI
        return status => {
          // AI
          const map = this.statusOptions?.reduce((acc, cur) => {
            // AI
            acc[cur.id] = cur.name // AI
            return acc // AI
          }, {}) // AI
          return map[status] || status // AI
        } // AI
      }, // AI
    },
    methods: {
      // AI
      // Show modal
      show() {
        // AI
        this.isShowModal = true
      },

      // Reset file input
      resetFileInput() {
        // AI
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = '' // AI
        }
      },

      // Close modal
      handleClose() {
        // AI
        this.isShowModal = false
        this.$emit('onLoad')
        this.resetData()
      }, // AI

      // Reset state
      resetData() {
        // AI
        this.isUploaded = false // AI
        this.processedItems = [] // AI
        this.successCount = 0
        this.failedCount = 0 // AI
      }, // AI
      // Download template
      async handleDownloadTemplate() {
        // AI
        this.loadingDownTemplate = true // AI
        try {
          // AI
          // const res = await downloadTemplateExcelTMDT()
          await ReceiptService.exportReceiptsTMDT() // AI
          // if (res) {
          //   const href = URL.createObjectURL(res)
          //   const link = document.createElement('a')
          //   link.href = href
          //   link.setAttribute('download', 'template-import.xlsx')
          //   document.body.appendChild(link)
          //   link.click()
          //   document.body.removeChild(link)
          //   URL.revokeObjectURL(href)
          // }
        } catch (e) {
          // AI
          console.log(e) // AI
          showMess(
            // AI
            this, // AI
            'Error', // AI
            e.message || 'Dã có lỗi xảy ra', // AI
            'danger', // AI
            'b-toaster-top-right', // AI
            5000 // AI
          ) // AI
        } finally {
          // AI
          this.loadingDownTemplate = false // AI
        }
      },

      // Handle file selection
      handleFileChange(event) {
        // AI
        const file = event.target.files[0] // AI
        if (file) {
          // AI
          this.uploadFile(file) // AI
        } // AI
      }, // AI

      // Process file upload
      async uploadFile(file) {
        // AI
        this.loadingUpload = true // AI
        try {
          // AI
          const formData = new FormData() // AI
          formData.append('file', file) // AI

          const response = await ReceiptService.importFileTMDT(formData) // AI

          if (response.code === 1000) {
            // AI
            // Map API response to table format
            this.processedItems = response.data.processDetails || [] // AI

            this.successCount = response.data.totalSuccess // AI
            // this.failedCount =
            //   response.data.totalProcessed - response.data.totalSuccess
            this.failedCount = response.data.totalProcessed // AI

            this.isUploaded = true // AI

            showMess(
              // AI
              this, // AI
              'Thành công', // AI
              `Tải lên thành công: ${this.successCount} | Thất bại: ${this.failedCount}`, // AI
              'success', // AI
              'b-toaster-top-right', // AI
              5000 // AI
            )
          } else {
            // AI
            showMess(
              // AI
              this, // AI
              'Lỗi', // AI
              response.message || 'Đã xảy ra lỗi khi xử lý file', // AI
              'danger', // AI
              'b-toaster-top-right', // AI
              5000 // AI
            ) // AI
          } // AI
        } catch (e) {
          // AI
          showMess(
            // AI
            this,
            'Error',
            e.message, // AI
            'danger',
            'b-toaster-top-right', // AI
            5000 // AI
          )
        } finally {
          // AI
          this.loadingUpload = false // AI
          this.resetFileInput() // AI
        } // AI
      }, // AI
    }, // AI
  } // AI
</script>

<style lang="scss" scoped>
  // AI
  .modal-body {
    // AI
    padding-top: 0; // AI
    max-height: 75vh; // AI
    height: 75vh; // AI
    overflow-y: auto; // AI
  } // AI

  .upload-container {
    // AI
    border: 2px dashed #dee2e6; // AI
    border-radius: 8px; // AI
    padding: 2rem; // AI
    margin: 1rem; // AI
    text-align: center; // AI
    display: flex; // AI
    flex-direction: column; // AI
    align-items: center; // AI
    justify-content: center; // AI

    .upload-icon {
      // AI
      display: flex; // AI
      justify-content: center; // AI
      align-items: center; // AI
      margin-bottom: 1rem; // AI

      i {
        // AI
        font-size: 48px; // AI
        color: #6c757d; // AI
      } // AI
    } // AI

    h5 {
      // AI
      margin-bottom: 1rem; // AI
    } // AI
  }
</style>
